<template>
    <div class="content-light">

        <el-card shadow="never" v-for="(item, index) in news" :key="index" class="news-item">
            <h3>{{item.name}}<span><i class="el-icon-time"></i> {{ item.created_at | moment("YYYY-MM-DD HH:mm") }}</span></h3>
            <div class="content" v-html="item.text"></div>

            <div v-if="item.offer">
                <router-link :to="{name: 'offer-view', params: { id: item.offer.id }}" tag="h4">
                    <a>{{item.offer.name}}</a>
                </router-link>
            </div>
        </el-card>

        <div class="pagination">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-count="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "News",
        data () {
            return {
                news: [],
                loading: false,
                page: 1,
                total_pages: 0
            };
        },
        created () {
            this.getNews();
            this.$store.commit("setNewsUnread", 0);
        },
        methods: {
            getNews () {
                this.loading = true;
                this.$axios.get('/news?page=' + this.page + '&expand=offer.actions').then((res) => {
                    this.news = res.data;
                    this.total_pages = parseInt(res.headers['x-pagination-page-count']);
                    this.loading = false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getNews()
            }
        }
    }
</script>

<style lang="scss" scoped>

    .news-item {
        h3 {
            display: flex;
            font-size: 16px;
            margin: 0px;
            span {
                margin-left: auto !important;
                color: #909399;
                font-size: 14px;
                font-weight: normal;
            }
        }
        .content {
            margin-top: 15px;
        }
        margin-bottom: 15px;
    }

</style>